module.exports = __webpack_public_path__ + "static/media/YB5F15_2.7b64e224.jpg";